var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7007 16.9999H3.59248C2.6065 16.9999 1.80371 16.1971 1.80371 15.2111V4.10295C1.80371 3.11697 2.6065 2.31409 3.59248 2.31409H14.7007C15.6882 2.31409 16.4895 3.11697 16.4895 4.10295V15.2111C16.4909 16.1986 15.6882 16.9999 14.7007 16.9999ZM3.59248 3.04515C3.00938 3.04515 2.53446 3.51985 2.53446 4.10295V15.2111C2.53446 15.7942 3.00938 16.2689 3.59248 16.2689H14.7007C15.2838 16.2689 15.7598 15.7942 15.7598 15.2111V4.10295C15.7598 3.51985 15.2853 3.04515 14.7007 3.04515H3.59248Z",
    fill: "#606368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03964 4.21461C5.83746 4.21461 5.6748 4.05053 5.6748 3.84981V1.36504C5.6748 1.16286 5.83892 1.00024 6.03964 1.00024C6.24034 1.00024 6.4059 1.16432 6.4059 1.36504V3.84981C6.40444 4.05053 6.24034 4.21461 6.03964 4.21461Z",
    fill: "#606368"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1963 4.21436C11.9942 4.21436 11.8301 4.05028 11.8301 3.84958V1.36479C11.8301 1.16261 11.9942 1 12.1963 1C12.3985 1 12.5612 1.16408 12.5612 1.36479V3.84958C12.5626 4.05028 12.3985 4.21436 12.1963 4.21436Z",
    fill: "#606368"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.123 6.44375H2.16656C1.96438 6.44375 1.80029 6.27967 1.80029 6.07895C1.80029 5.87823 1.96438 5.71411 2.16656 5.71411H16.123C16.3252 5.71411 16.4893 5.87823 16.4893 6.07895C16.4893 6.27967 16.3252 6.44375 16.123 6.44375Z",
    fill: "#606368"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.d1bc3198.svg";
export { ForwardRef as ReactComponent };